import { Theme } from '@nesto/themes';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components/macro';

export const useTheme = () => useContext<Theme>(ThemeContext) || {};
